"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BaseFab = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return {
    root: {
      boxSizing: 'content-box',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      padding: spacing(1),
      minHeight: spacing(6),
      maxHeight: spacing(6),
      minWidth: spacing(6),
      maxWidth: spacing(6),
      '& > *': {
        maxWidth: "calc(100% - ".concat(spacing(2), ")"),
        maxHeight: "calc(100% - ".concat(spacing(2), ")")
      }
    },
    dense: {
      padding: spacing(0.5),
      minHeight: spacing(4),
      maxHeight: spacing(4),
      minWidth: spacing(4),
      maxWidth: spacing(4),
      '& > *': {
        maxWidth: "calc(100% - ".concat(spacing(1), ")"),
        maxHeight: "calc(100% - ".concat(spacing(1), ")")
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

function Fab(props, ref) {
  var classes = useStyles();
  return (0, _core.jsx)(_Button["default"], (0, _extends2["default"])({
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, props.dense && classes.dense], ";label:Fab;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
    ref: ref
  }, props));
}

__signature__(Fab, "useStyles{classes}", function () {
  return [useStyles];
});

var BaseFab = (0, _react.forwardRef)(Fab);
exports.BaseFab = BaseFab;

var _default = (0, _react.forwardRef)(Fab);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Fab/index.tsx");
  reactHotLoader.register(Fab, "Fab", "/builds/bA1zbJom/0/gojob/ui-bits/src/Fab/index.tsx");
  reactHotLoader.register(BaseFab, "BaseFab", "/builds/bA1zbJom/0/gojob/ui-bits/src/Fab/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Fab/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();